var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlinkIcon = function SvgUnlinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "unlink-icon_svg__a",
    width: "105.8%",
    height: "104.5%",
    x: "-2.9%",
    y: "-1.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlink-icon_svg__c",
    width: "120.3%",
    height: "129%",
    x: "-10.1%",
    y: "-11.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.220941876 0 0 0 0 0.419582201 0 0 0 0.247295673 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "unlink-icon_svg__b",
    d: "M0 60h800v1022H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "unlink-icon_svg__d",
    d: "M0 0h548v383H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-672-381H768V643H-672z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72 -225)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unlink-icon_svg__b",
    fill: "#000",
    filter: "url(#unlink-icon_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unlink-icon_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#474D55"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(-16 17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17.5
  }, "Sponsor Legal Representative")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 14,
    fontWeight: 500,
    transform: "translate(-48 17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 50
  }, "Monika Derfflinger")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    transform: "translate(-48 17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    y: 81
  }, "+(999) 345 76 78"))), /*#__PURE__*/React.createElement("path", {
    fill: "#031022",
    fillOpacity: 0.867,
    d: "M-672-381H768V643H-672z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226 -60)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unlink-icon_svg__d",
    fill: "#000",
    filter: "url(#unlink-icon_svg__c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#unlink-icon_svg__d",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25,
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F7",
    stroke: "#6E7780",
    d: "M44.068 36.505 48 32.572c4.26-4.26 11.168-4.26 15.428 0s4.26 11.168 0 15.428l-4.498 4.497h0m-6.557 6.558L48 63.428c-4.26 4.26-11.168 4.26-15.428 0s-4.26-11.168 0-15.428l4.179-4.178h0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C83133",
    d: "m60.167 60 4.666 4M30.167 31l4.666 4M27.167 40h4.666M40 27.167v4.666M56 63v4M63 56h4"
  })))));
};
export default SvgUnlinkIcon;